import { FilterType, Table } from "@components";
import { Cell, Row } from "@components/table/types";
import { Box, Grid, Button, Typography, IconButton } from "@material-ui/core";
import * as React from "react";
import { useState } from "react";
import { M_TABLE_HEADERS_APPROVERDISTRO } from "../constants";
import { useHistory } from "react-router-dom";
import {
  createStyles,
  Theme,
  withStyles,
  WithStyles,
} from "@material-ui/core/styles";
import { ApproverDistroDetails } from "./detail";
import { Member } from "./detail/member";
import { ApproverDistro } from "@api/types/approverDistro";
import api from "@api";
import { Form } from "@components";
import { useEffect } from "react";
import { useApproverDistroStore } from "../../../../../store/hooksy";
import { MaintenanceBreadcrumbs } from "../breadcrumbs";
import SupervisorAccountIcon from "@material-ui/icons/SupervisorAccount";
import { exportDistroGroupsToExcel } from "@api/excel-exporters/exportDistroGroups";

const headers: Cell[] = [
  { data: M_TABLE_HEADERS_APPROVERDISTRO.NAME },
  { data: M_TABLE_HEADERS_APPROVERDISTRO.IS_ACTIVE },
  { data: M_TABLE_HEADERS_APPROVERDISTRO.DISTRO_MEMBERS },
];

export const ApproversDistro: React.FC = () => {
  const [
    approverDistroStore,
    setApproverDistroStore,
  ] = useApproverDistroStore();

  useEffect(() => {
    if (approverDistroStore.fetchList) {
      getDataList();
    }
  }, [approverDistroStore]);

  const form = Form.useManager<ApproverDistro>({
    id: 0,
    name: "",
    isActive: true,
  });

  const [openDistroDetail, setOpenDistroDetail] = useState<boolean>(false);
  const [openDistroMember, setOpenDistroMember] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [selectedDistro, setSelectedDistro] = useState<ApproverDistro>();
  const [distroList, setDistroList] = useState([]);
  const [
    selectedApproverDistroForMember,
    setSelectedApproverDistroForMember,
  ] = useState({
    id: 0,
    name: "",
  });

  useEffect(() => {
    getDataList();
  }, []);

  useEffect(() => {
    if (openDistroDetail) {
      if (selectedDistro) {
        form.set(Form.target.VALUE, ["id", selectedDistro.id]);
        form.set(Form.target.VALUE, ["name", selectedDistro.name]);
        form.set(Form.target.VALUE, ["isActive", selectedDistro.isActive]);
      }
    }
  }, [openDistroDetail]);

  const openDistroMemberModal = (data: any) => {
    setSelectedApproverDistroForMember({
      id: data.id,
      name: data.name,
    });

    setOpenDistroMember(true);
  };

  function getDataList() {
    api.approverDistro
      .getApproverDistro()
      .then((response) => {
        setDistroList(response.mappvrDistro);
      })
      .catch((error) => {
        console.error(`Error in fetching distro list ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        setApproverDistroStore({ fetchList: false });
      });
  }

  const viewMembersIcon = (
    <span
      style={{
        display: "flex",
        justifyContent: "left",
        alignItems: "left",
      }}
    >
      <SupervisorAccountIcon />
    </span>
  );

  function handleExport() {
    exportDistroGroupsToExcel();
  }

  const pageName = "Approvers Distro";
  return (
    <Box mt={2}>
      <MaintenanceBreadcrumbs title={pageName} />
      <Button style={{ float: "right" }} onClick={handleExport}>
        EXPORT TO EXCEL
      </Button>
      <ApproverDistroDetails
        form={form}
        open={openDistroDetail}
        onCancel={() => setOpenDistroDetail(false)}
      />
      <Member
        open={openDistroMember}
        selectedApproverDistro={selectedApproverDistroForMember}
        onCancel={() => setOpenDistroMember(false)}
      />
      <Table
        data={distroList.map((data: any) => ({
          cells: [
            {
              data: data.name,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                setSelectedDistro(data);
                setOpenDistroDetail(true);
              },
            },
            {
              data: data.isActive ? "Yes" : "No",
            },
            {
              data: viewMembersIcon,
              color: "blue",
              cursor: "pointer",
              onClick: () => {
                openDistroMemberModal(data);
              },
            },
          ],
          data,
        }))}
        tableName={pageName}
        searchPlaceholder="Search by Name"
        searchColumns={[M_TABLE_HEADERS_APPROVERDISTRO.NAME]}
        headers={headers}
        filters={[FilterType.SORT, FilterType.SEARCH, FilterType.PAGINATOR]}
        toolbar="M_APPROVER_DISTRO_TOOLBAR"
        loading={isLoading}
      />
    </Box>
  );
};
